import { useIsAdhaJourney } from '@/core/hooks';
import { PropertyDetailsAdhaShell } from '@/modules/property-details/PropertyDetailsAdhaShell';
import { Stack, router, useFocusEffect } from 'expo-router';
import React, { useCallback, useEffect, useState } from 'react';
import { BackHandler, Platform } from 'react-native';

type DetailsScreen = React.ComponentType;

/**
 * Native-only route (web uses property-details.web.tsx).
 * ADHA: light shell first so the card transition is not blocked, then the
 * full mobile details screen. Non-ADHA: same owned-property screen as before.
 */
export default function PropertyDetailsRoute() {
  const isAdhaJourney = useIsAdhaJourney();
  const [AdhaScreen, setAdhaScreen] = useState<DetailsScreen | null>(null);

  useFocusEffect(
    useCallback(() => {
      if (Platform.OS === 'web') {
        return;
      }

      const onBackPress = () => {
        if (router.canGoBack()) {
          router.back();
        } else {
          router.replace('/(auth)/(home)');
        }
        return true;
      };

      const subscription = BackHandler.addEventListener(
        'hardwareBackPress',
        onBackPress,
      );
      return () => subscription.remove();
    }, []),
  );

  useEffect(() => {
    if (!isAdhaJourney) {
      return;
    }
    let cancelled = false;
    void import('@/modules/property-details/PropertyDetailsScreenAdhaMobile').then(
      (mod) => {
        if (!cancelled) {
          setAdhaScreen(() => mod.PropertyDetailsScreenAdhaMobile);
        }
      },
    );
    return () => {
      cancelled = true;
    };
  }, [isAdhaJourney]);

  if (!isAdhaJourney) {
    const { PropertyDetailsScreen } =
      require('@/modules/property-details/PropertyDetailsScreen') as {
        PropertyDetailsScreen: DetailsScreen;
      };
    return (
      <>
        <Stack.Screen options={{ gestureEnabled: true }} />
        <PropertyDetailsScreen />
      </>
    );
  }

  return (
    <>
      <Stack.Screen
        options={{
          gestureEnabled: true,
          fullScreenGestureEnabled: false,
        }}
      />
      {AdhaScreen ? <AdhaScreen /> : <PropertyDetailsAdhaShell />}
    </>
  );
}
